import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@components/ui/button';

export const NoMatch = () => (
    <div className="flex min-h-[400px] flex-col items-center justify-center gap-4 text-center">
        <h1 className="text-2xl font-semibold tracking-tight">
            Page not found
        </h1>
        <p className="text-sm text-muted-foreground">
            The page you are looking for does not exist.
        </p>
        <Button asChild>
            <Link to="/">Go home</Link>
        </Button>
    </div>
);
